export default {"src":"/_next/static/media/constraction.2a7a300f.svg","height":261,"width":280,"blurWidth":0,"blurHeight":0};